export default "__VITE_ASSET__JmNB4Io9__";